module.exports = __webpack_public_path__ + "img/illustration.b4d49322.svg";